<template>
  <div style="position: relative">
  <div class="activity-mask" v-if="showMaskBg === true"></div>
  <Block class="activity-time" title="参赛投稿">
    <Tabs class="tab-wrapper" scene="pure" divider size="large" v-model:active="active" :items="[
      { title: '精选作品', name: 'remarked' },
      { title: '所有作品', name: 'all' },
      { title: '我的投稿', name: 'mine' },
      ]">
      <template #remarked> </template>
      <template #all> </template>
      <template #mine> </template>
    </Tabs>
    <div class="wrapper">
      <Feed v-if="active === 'remarked'" type="remarked" @showMask="showMask"/>
      <Feed v-if="active === 'all'" type="all" @showMask="showMask"/>
      <Feed v-if="active === 'mine'" type="mine" @showMask="showMask"/>
    </div>
  </Block>

  </div>

</template>

<script setup lang="ts">
import Block from "./common/block.vue";
import Tabs from "./common/tabs.vue";
import Feed from "./common/Feed.vue";

const active = ref("remarked");
const showMaskBg = ref(true);

const showMask = (isShowMask:boolean) => {
  showMaskBg.value = isShowMask;
}
</script>

<style scoped lang="less">
.activity-time {
  .tab-wrapper {
    width: 25.36rem;
    margin-top: 0.8rem;
    padding-left: 0.25rem;
    z-index: 299;

    @media screen and(max-width: 1360px) {
      margin-top: 0.32rem;
      width: 100%;
    }

    :deep(.van-tabs) {
      &__wrap {
        justify-content: center;
      }

      &__line {
        width: 0.65rem;
        // bottom: 0.35rem;
        @media screen and(max-width: 1360px) {
          width: 0.4rem;
          bottom: 0.3rem;
        }
      }
    }
  }
}
.activity-mask {
    width: 100%;
    height: 4rem;
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    pointer-events: none;
    background-size: 100% 100%;
    background-image: url(https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/9057657b-5b56-4773-aa29-2958c94ea2ec.png);
    z-index: 2;
  @media screen and (max-width: 1360px) {
      height: 2.4rem;
      background-size: 100% 100%;
      background-image: url(https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/9057657b-5b56-4773-aa29-2958c94ea2ec.png);
    }
}
.activity-content {
  width: 22.4rem;

  @media screen and(max-width: 1360px) {
    width: 100%;
  }
}
</style>
